import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import "../tps.css";

const PlatformList = () => {
  const [platforms, setPlatforms] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filtered, setFiltered] = useState([]);
  const navigate = useNavigate();
  const API = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchPlatforms = async () => {
      try {
        const res = await axios.get(`${API}/api/host/platforms`);
        setPlatforms(res.data);
        setFiltered(res.data);

        console.log(res.data);

      } catch (err) {
        console.error('Failed to fetch platforms:', err);
      }
    };
    fetchPlatforms();
  }, [API]);

  useEffect(() => {
    const term = searchTerm.trim().toLowerCase();
    if (term === '') {
      setFiltered(platforms);
    } else {
      setFiltered(
        platforms.filter((p) =>
          p.PlatformName.toLowerCase().includes(term)
        )
      );
    }
  }, [searchTerm, platforms]);

  const handlePlatformClick = (platformID,SubmissionMode) => {
    localStorage.setItem('platformID', platformID);
    localStorage.setItem('SubmissionMode', SubmissionMode);
    navigate('../cl');
  };

  return (
    <div className="container mt-5">
      <h2 className="mb-4 fw-medium">Available Platforms</h2>

      {/* Search Input */}
      <div className="mb-3 w-50">
        <input
          type="text"
          className="form-control"
          placeholder="Search Platforms..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>


      <div className="row">
        {filtered.map((platform) => (
          <div className="col-md-4 mb-3 " key={platform.PlatformID}>
            <div
              className="card shadow-sm platform-card"
              onClick={() => handlePlatformClick(platform.PlatformID ,platform.SubmissionMode )}
              style={{ cursor: 'pointer' }}
            >
              <div className="card-body">
                <h5 className="card-title">{platform.PlatformName}</h5>
              </div>
            </div>
          </div>
        ))}
        {filtered.length === 0 && (
          <div className="col-12">
            <p>No platforms match your search.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PlatformList;
